module.exports = __webpack_public_path__ + "img/icon_zweitmeinung_iso.62fde5ce.svg";